/**
 * 顧客周りの記述
 */
const MikihouseCustomer = {
  Actions: {
    getCustomerCookie: () => {
      let customerId = Cookies.get('customerId')
      const accessToken = Cookies.get('access_token')
      const referrerLocation = Cookies.get('location')
      if (!customerId || customerId == 'false' || customerId == 'undefined') {
        customerId = localStorage.getItem('customerid')
      }
      return {
        "customerId": customerId,
        "accessToken": accessToken,
        "referrerLocation": referrerLocation
      }
    },
    setCustomerCookie: (key, value, p = '/') => {
      const cookieData = { path: p }
      if (navigator.userAgent.match(/Yappli|yappli/)) {
        cookieData['expires'] = 7
      }
      const set = Cookies.set(key, value, cookieData)
      return true
    },
    fetchCustomer: (endpoint, headers) => {
      return new Promise((resolve, reject) => {
        // const url = 'https://customapp.mikihouse.co.jp/prd/api/v1/frontend/customers/' + endpoint
        const url = `${MIKIHOUSE.BASE_CUSTOMER_API_URL}/api/v1/frontend/customers/${endpoint}`;
        fetch(url, headers)
          .then(res => res.json())
          .then(res => {
            resolve(res)
          })
          .catch(error => reject(error))
      })
    },
    errorTextReset: () => {
      const errorReseter = document.querySelectorAll('.error')
      const errorMessageReset = document.querySelectorAll('.errorMessage')
      errorReseter.forEach((e) => {
        e.classList.remove('error');
      });
      errorMessageReset.forEach((e) => {
        e.innerText = '';
      });
      return true
    },
    emailCollation: (customerPassword, customerPassword2) => {
      let passwordSome;
      if (customerPassword != customerPassword2) {
        passwordSome = {
          error: true,
          error_message: MIKIHOUSE['language'].customer[Shopify.locale].error00
        };
      } else {
        passwordSome = {
          error: false
        }
      }
      return passwordSome
    },
    provinceNumberSet: (provinceList) => {
      Array.from(provinceList.options).forEach((e, index) => {
        i = index;
        ret = ('00' + i).slice(-2);
        if (i != 0) {
          e.value = ret;
        }
      });
    },
    responseErrorModal: (status_code, path, recover = false) => {
      if (recover === true && status_code === 3001) {
        MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error60)
        return
      }
      switch (status_code) {
        case 3001:
          if (path == '/tokens') {
            MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error01)
          } else {
            MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error02)
          }
          break;
        case 3002:
          //alert('リフレッシュトークンが無い');
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error03)
          break;
        case 3003:
          //alert('すでにアカウントがある');
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error04)
          break;
        case 3004:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error05)
          break;
        case 3005:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error06)
          //alert('リフレッシュトークンのHashが正しくない');
          break;
        case 3006:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error07)
          //alert('配送情報が存在しない');
          break;
        case 3007:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error08)
          //alert('パスワード変更時に、変更前と変更後のパスワードが同じ');
          break;
        case 3008:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error09)
          //alert('カスタマーサービスにデータが無い');
          break;
        case 3009:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error20)
          //alert('カスタマーサービスにデータが無い');
          break;
        case 3010:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error21)
          //alert('カスタマーサービスにデータが無い');
          break;
        case 4000:
          //alert('');
          break;
        case 4001:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error22)
          //alert('お客様が手入力するリクエストパラメータで必須入力なのに、値が空だったり、文字数が間違っている場合などの入力不備の場合');
          break;
        case 4002:
          //alert('呼び元のシステムで必ず指定してもらうリクエストパラメータがそもそも指定されていなかったり、アクセストークンなどのシステムで設定する値が不正な場合');
          if (path.match(/regist_authenticate/) || path.match(/mail_authenticate/) || path.match(/password_authenticate/)) {
            MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error23)
          } else {
            MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error24)
          }
          break;
        case 4003:
          // 住所の重複
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error25)
          break;
        case 5000:
          MikihouseCustomer.Actions.errorContent('reload', MIKIHOUSE['language'].customer[Shopify.locale].error26)
          //alert('DBへの読み取りや更新の際にエラーが発生したとき');
          break;
        case 6000:
          MikihouseCustomer.Actions.errorContent('reload', MIKIHOUSE['language'].customer[Shopify.locale].error27)
          //alert('以下Cognitoエラー以外の、Cognitoのエラーが発生したとき。');
          break;
        case 6001:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error28)
          //alert('ユーザーネームかパスワード間違い');
          break;
        case 6002:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error29)
          //alert('メール認証が終わっていないユーザーがログインしようとしたとき');
          break;
        case 6003:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error30)
          //alert('登録しようとしているユーザー名が既に登録済みのとき');
          break;
        case 6004:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error31)
          //alert('認証時に、同一ユーザー名が登録済みのとき');
          break;
        case 6005:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error32)
          //alert('パスワード要件を満たしていないとき');
          break;
        case 6006:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error33)
          //alert('認証コードが間違っている');
          break;
        case 6007:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error34)
          //alert('認証コードが期限切れ');
          break;
        case 6008:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error35)
          //alert('更新処理などの際に、対象ユーザーが存在しないとき');
          break;
        case 6009:
          MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error36)
          //alert('認証回数やログイン試行回数が上限に達したとき');
          break;
        case 6010:
          MikihouseCustomer.Actions.errorContent('reload', MIKIHOUSE['language'].customer[Shopify.locale].error37)
          //alert('Cognitoのクォータに達したとき');
          break;
        case 6011:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error38)
          //alert('AccessToken関連のエラー。以下のAccessTokenエラー以外のエラーのとき。');
          break;
        case 6012:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error39)
          //alert('トークンの形式がおかしいとき。意図的にトークンの形式を変えて送ってきている場合。');
          break;
        case 6013:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error40)
          //alert('トークンが期限切れの時。');
          break;
        case 6014:
          MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error41)
          //alert('トークンが期限切れの時。');
          break;
        case 9000:
          MikihouseCustomer.Actions.errorContent('reload', MIKIHOUSE['language'].customer[Shopify.locale].error42)
          //alert('上記以外のタイミングでエラーが起こった時');
          break;
        default:
          break;
      }
    },
    errorContent: (error, errorText) => {
      document.querySelector('#loading').classList.remove('active');
      document.querySelector('#errorText').innerText = '';
      document.querySelector('#errorTextWrap').style.display = 'flex';
      document.querySelector('#errorText').innerHTML = errorText;
      console.log(document.querySelector('#errorText').innerText);
      switch (error) {
        case 'close':
          document.querySelector('#errorClose').style.display = 'block';
          break;
        case 'logout':
          document.querySelector('#errorLogout').style.display = 'block';
          break;
        case 'reload':
          document.querySelector('#errorReload').style.display = 'block';
          break;
        default:
          break;
      }
    },
    coercionLogout: () => {
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      if(!cookie.accessToken || cookie.accessToken === 'false') {
        fetch('/account/logout')
          .then(() => {
            location.href = '/account/login'
          })
      }
      if (!cookie.customerId || cookie.customerId === 'false') {
        MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error44)
      }
    },
    errorLogic: (error, key) => {
      let prefix = ''
      if(key.endsWith('last_name')) {
        prefix = '姓'
      }
      if(key.endsWith('first_name')) {
        prefix = '名'
      }
      if(key.endsWith('last_name_kana')) {
        prefix = 'セイ'
      }
      if(key.endsWith('first_name_kana')) {
        prefix = 'メイ'
      }
      document.querySelector('.errorMessage[data-target="' + key + '"]').innerText = prefix + error.error_message 
      document.querySelector('input[data-target="' + key + '"], select[data-target="' + key + '"]').classList.add('error');
    }
  },
  Register: {
    codeIssuance: {
      init: () => {
        const termChecker = document.querySelector('#term-checkbox')
        const passwordOpen = document.querySelectorAll('a[data-password-target]')
        const form = document.forms['register']
        termChecker.addEventListener('change', (e) => MikihouseCustomer.Register.codeIssuance.termCheck(e.target));
        passwordOpen.forEach((e) => MikihouseCustomer.Register.codeIssuance.passwordOpener(e))
        form.addEventListener('submit', async (e) => {
          e.preventDefault()
          const email = e.target.elements['customerEmail']
          const password = e.target.elements['customerPassword']
          const confirmationPassword = e.target.elements['customerPassword2']
          const emailCheck = MIKIHOUSE.validation.validationEmail(email.value)
          const passwordCheck = MIKIHOUSE.validation.validationPassword(password.value)
          const emailCollationCheck = MikihouseCustomer.Actions.emailCollation(password.value, confirmationPassword.value)
          const errorReset = MikihouseCustomer.Actions.errorTextReset()
          const loadingElement = document.querySelector('#loading')

          let submitEvt = false
          loadingElement.classList.add('active');
          if (!emailCheck.error && !passwordCheck.error && !emailCollationCheck.error) {
            submitEvt = true
          }
          if (submitEvt == false) {
            loadingElement.classList.remove('active');
            MikihouseCustomer.Register.codeIssuance.errorLogic(passwordCheck, emailCheck, emailCollationCheck, password, email, confirmationPassword)
          } else {
            const result = await MikihouseCustomer.Register.codeIssuance.emailRegister(customerEmail.value, customerPassword.value);
            if (result.message == 'success.') {
              localStorage.setItem('registerPassword', password.value);
              localStorage.setItem('registerMailAddress', email.value);
              location.href = '/pages/mail-authcode';
            } else {
              MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/id')
              loadingElement.classList.remove('active');
            }
          }
        })
      },
      emailRegister: (email, passwd) => {
        const endpoint = 'id'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify({
            'mail': email,
            'password': passwd,
            'referrer': new URL(window.location.href).searchParams.get('referrer'),
          })
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
      errorLogic: (passwordCheck, emailCheck, emailCollationCheck, password, email, confirmationPassword) => {
        if (passwordCheck.error) {
          document.querySelector('.errorPassword').innerText = passwordCheck.error_message;
          password.classList.add('error');
        }
        if (emailCheck.error) {
          document.querySelector('.errorEmail').innerText = emailCheck.error_message;
          email.classList.add('error');
        }
        if (emailCollationCheck.error) {
          document.querySelector('.errorPassword2').innerText = emailCollationCheck.error_message;
          confirmationPassword.classList.add('error');
        }
      },
      termCheck: (target) => {
        if (target.checked) {
          document.querySelector('#submit_btn_overlay').style.display = 'none'
          document.querySelector('#registerEmailBtn').disabled = false;
        } else if (!target.checked) {
          document.querySelector('#submit_btn_overlay').style.display = 'block'
          document.querySelector('#registerEmailBtn').disabled = true;
        }
      },
      passwordOpener: (e) => {
        e.addEventListener('click', elm => {
          const id = elm.target.dataset.passwordTarget
          elm.target.classList.toggle('active')
          if (elm.target.classList.contains('active')) {
            document.querySelector('#' + id).setAttribute('type', 'text')
          } else {
            document.querySelector('#' + id).setAttribute('type', 'password')
          }
        })
      }
    },
    emailAuthentication: {
      init: () => {
        const RegisterFormEmail = document.querySelector('#RegisterForm-email')
        const RegisterFormAuthcode = document.querySelector('#RegisterForm-authcode')
        const form = document.querySelector('#RegisterForm')
        RegisterFormEmail.value = localStorage.getItem('registerMailAddress');
        if (!document.referrer.match(/account\/register/)) {
          RegisterFormEmail.value = localStorage.getItem('upemail');
        }

        form.addEventListener('submit', (e) => MikihouseCustomer.Register.emailAuthentication.submitAction(e))
      },
      submitAction: async (e) => {
        e.preventDefault()
        MikihouseCustomer.Actions.errorTextReset()
        const cookie = MikihouseCustomer.Actions.getCustomerCookie()
        const email = e.target.elements['customer[email]']
        const authcode = document.querySelector('#RegisterForm-authcode')
        const loadingElement = document.querySelector('#loading')
        const emailCheck = MIKIHOUSE.validation.validationEmail(email.value)
        const authcodeCheck = MIKIHOUSE.validation.validationAuthcode(authcode.value)
        let submitEvt = false
        let result
        loadingElement.classList.add('active');
        if (!emailCheck.error && authcodeCheck.error) {
          submitEvt = true
        }
        if (submitEvt == true) {
          loadingElement.classList.remove('active');
          MikihouseCustomer.Register.emailAuthentication.errorLogic(emailCheck, authcodeCheck, email, authcode)
        } else {

          if (document.referrer.match(/account\/register/)) {
            result = await MikihouseCustomer.Register.emailAuthentication.certificationCode(email.value, authcode.value);
          } else {
            result = await MikihouseCustomer.Register.emailAuthentication.updateEmailAddressCertificationCode(cookie, email.value, authcode.value);
          }
          if (result.message == 'success.') {
            localStorage.setItem('customerid', result.id)
            result = await MikihouseCustomer.Actions.setCustomerCookie('customerId', result.id, '/')
            // document.cookie = 'customerId=' + result.id + '; path=/;';
            setTimeout(() => {
              if (document.referrer.match(/account\/register/)) {
                location.href = '/pages/account-register';
              } else {
                location.href = '/pages/update-mailaddress?update=true';
              }
            }, 300)

          } else {
            MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/regist_authenticate')
            loadingElement.classList.remove('active');
          }
        }

      },
      certificationCode: (email, authcode) => {
        const endpoint = 'regist_authenticate'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify({
            'mail': email,
            'confirmation_code': authcode
          })
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
      updateEmailAddressCertificationCode: (cookie, email, authcode) => {
        const endpoint = cookie.customerId + '/mail_authenticate'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json',
            'X-Mikihouse-Crm-Access-Token': cookie.accessToken
          },
          'body': JSON.stringify({
            'mail': email,
            'confirmation_code': authcode
          })
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
      errorLogic: (emailCheck, authcodeCheck, email, authcode) => {
        if (emailCheck.error) {
          document.querySelector('.errorPassEmail').innerText = emailCheck.error_message;
          email.classList.add('error');
        }
        if (authcodeCheck.error) {
          document.querySelector('.errorPassAuthcode').innerText = authcodeCheck.error_message;
          authcode.classList.add('error');
        }
      },
      authorization: (email, authcode) => {
        const endpoint = 'regist_authenticate'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify({
            'mail': email,
            'confirmation_code': authcode
          })
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
    },
    addressRegister: {
      init: () => {
        const provinceList = document.querySelector('#province-list')
        const addBabyBtn = document.querySelector('#add-baby-btn')
        const addKidsBtn = document.querySelector('#add-kid-btn')
        const childrenAddBtn = document.querySelectorAll('.btn-wh-redborder')
        const editBaby = document.querySelector('#edit-baby-btn')
        const editKids = document.querySelector('#edit-kid-btn')
        const jsonContent = document.querySelector('#childrenListJson')
        const form = document.querySelector('#prodRegister')
        let json = JSON.parse(jsonContent.textContent)
        MikihouseCustomer.Actions.provinceNumberSet(provinceList)
        /**** */
        for (let i = 0; i < childrenAddBtn.length; i++) {
          childrenAddBtn[i].addEventListener('click', (e) => {
            const id = e.target.dataset.target
            const field = document.querySelectorAll('.children-input-field')
            document.querySelector('#add-kid-btn').style.display = 'inline-block'
            document.querySelector('#edit-kid-btn').style.display = 'none'
            document.querySelector('#add-baby-btn').style.display = 'inline-block'
            document.querySelector('#edit-baby-btn').style.display = 'none'
            for (let i = 0; i < field.length; i++) {
              field[i].classList.add('hide')
            }
            document.querySelector('#' + id).classList.remove('hide')
          })
        }
        /**** */
        addBabyBtn.addEventListener('click', (e) => MikihouseCustomer.Register.addressRegister.addBaby(e))
        addKidsBtn.addEventListener('click', (e) => MikihouseCustomer.Register.addressRegister.addKids(e))
        editBaby.addEventListener('click', (evt) => MikihouseCustomer.Register.addressRegister.childrenEditer(evt, evt.target.dataset.seq, 'baby'))
        editKids.addEventListener('click', (evt) => MikihouseCustomer.Register.addressRegister.childrenEditer(evt, evt.target.dataset.seq, 'kids'))
        prodRegister.addEventListener('submit', async (e) => {
          e.preventDefault()
          const cookie = MikihouseCustomer.Actions.getCustomerCookie()
          const jsonContent = document.querySelector('#childrenListJson')
          const loadingElement = document.querySelector('#loading')
          const errorReset = MikihouseCustomer.Actions.errorTextReset()
          let json = JSON.parse(jsonContent.textContent)
          loadingElement.classList.add('active');
          loadingElement.querySelector('[data-text]').style.display = 'block'
          console.log(cookie)
          if (!cookie.customerId || cookie.customerId == 'false' || cookie.customerId == 'undefined') {
            cookie.customerId = localStorage.getItem('customerid')
          }
          let submitAction = false
          const array = {}
          for (let i = 0; i < e.target.elements.length; i++) {
            const elmKey = e.target.elements[i]
            if (elmKey.dataset.target) {
              if (elmKey.dataset.target == 'mail_magazine_flg') {
                array[elmKey.dataset.target] = elmKey.checked == true ? '0' : '1'
              } else {
                array[elmKey.dataset.target] = elmKey.value
              }
            }
          }
          let error = false
          let errorFlg = false
          for (let k in array) {
            if (k == 'last_name' || k == 'first_name') {
              array[k] = array[k].trim()
              error = await MIKIHOUSE.validation.validationName(array[k])
            }
            if (k == 'last_name_kana' || k == 'first_name_kana') {
              array[k] = array[k].trim()
              error = await MIKIHOUSE.validation.validationKanaName(array[k])
            }
            if (k == 'zip') {
              error = await MIKIHOUSE.validation.validationZipcode(array[k])
            }
            if (k == 'phone') {
              error = await MIKIHOUSE.validation.validationPhone(array[k])
            }
            if (k == 'city') {
              array[k] = array[k].replace(/\s/g, '')
              error = await MIKIHOUSE.validation.validationCity(array[k], true, 24)
            }
            if (k == 'address1') {
              array[k] = array[k].replace(/\s/g, '')
              error = await MIKIHOUSE.validation.validationCity(array[k], true)
            }
            if (k == 'address2') {
              array[k] = array[k].replace(/\s/g, '')
              error = await MIKIHOUSE.validation.validationCity(array[k])
            }
            if (error.error && k != 'prefecture' && k != 'mail_magazine_flg') {
              errorFlg = true
              MikihouseCustomer.Register.addressRegister.errorLogic2(error, k)
            }
          }
          if (!cookie.customerId || cookie.customerId == 'false' || cookie.customerId == 'undefined') {
            cookie.customerId = localStorage.getItem('customerid')
          }
          array['id'] = cookie.customerId

          array['children'] = json
          if (errorFlg != false) {
            document.body.scrollIntoView()
            loadingElement.classList.remove('active');
            loadingElement.querySelector('[data-text]').style.display = 'none'
            return false
          } else {
            const result = await MikihouseCustomer.Register.addressRegister.submitAction(array)
            if (result.status_code == 1000) {
              cookie.referrerLocation = location.origin + Shopify.routes.root
              const login = await MikihouseCustomer.Register.addressRegister.customerLogin(cookie)
              if (login.redirect_url) {
                // 機種変更や複数端末利用を想定し、ヤプリでのログイン時は毎回ヤプリSDKでの登録を行う
                if (MikihouseCustomer.YappliCaller.isYappliWebView() && login.member_no) {
                  let result2 = await MikihouseCustomer.YappliCaller.registMemberNo(login.member_no);
                  if (result2.status) {
                    // ヤプリステータスが未連携の場合はヤプリステータスを更新する
                    if (Boolean(login.yappli_status)) {
                      result2 = await MikihouseCustomer.YappliStatus.updateYappliStatus(login.crm_customer_id, login.access_token);
                      if (result2.status_code !== 1000) {
                        MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error45);
                        loadingElement.classList.remove('active');
                        loadingElement.querySelector('[data-text]').style.display = 'none'
                        return;
                      }
                    }
                  }
                  else {
                    MikihouseCustomer.Actions.errorContent('logout', MIKIHOUSE['language'].customer[Shopify.locale].error46);
                    loadingElement.classList.remove('active');
                    loadingElement.querySelector('[data-text]').style.display = 'none'
                    return;
                  }
                }
                location.href = login.redirect_url
              } else {
                location.href = '/account/login?createCustomer=true'
              }
            } else {
              MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/regist_authenticate')
              loadingElement.classList.remove('active')
              loadingElement.querySelector('[data-text]').style.display = 'none'
            }
          }

        })
      },
      submitAction: (dafaultAddress) => {
        console.log(dafaultAddress)
        const endpoint = ''
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify(dafaultAddress)
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
      customerLogin: (cookie) => {
        const endpoint = 'tokens'
        const headers = {
          'method': 'POST',
          'headers': {
            'Content-Type': 'application/json'
          },
          'body': JSON.stringify({
            'mail': localStorage.getItem('registerMailAddress'),
            'callback_url': `${location.origin + Shopify.routes.root}/`,
            'password': localStorage.getItem('registerPassword')
          })
        }
        const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
        return result
      },
      addBaby: () => {
        const babyBirthday = document.querySelector('#baby-birthday')
        const babyRelation = document.querySelector('#baby-relation')
        const babySex = document.querySelector('#baby-sex')
        const jsonContent = document.querySelector('#childrenListJson')
        MikihouseCustomer.Actions.errorTextReset()
        let json = JSON.parse(jsonContent.textContent)
        if (json.length > 9) {
          alert(MIKIHOUSE['language'].customer[Shopify.locale].error47)
          return true
        }
        const baby = {}
        const list = document.querySelector('#add-kids-list')
        baby['seq'] = json.length + 1
        baby['last_name'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
        baby['first_name'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
        baby['last_name_kana'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
        baby['first_name_kana'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
        baby['sex'] = babySex.value
        baby['born_flg'] = '0'
        baby['birthday'] = babyBirthday.value
        baby['relationship'] = babyRelation.value
        json.push(baby)
        for (let seq = 0; seq < json.length; seq++) {
          json[seq]['seq'] = seq + 1
        }
        jsonContent.textContent = JSON.stringify(json)
        const kidsHTML = MikihouseCustomer.Register.addressRegister.addChildrenList(baby, 'baby')
        list.innerHTML = list.innerHTML + kidsHTML
        const listItem = document.querySelectorAll('.kids-list')
        for (let iii = 0; iii < listItem.length; iii++) {
          listItem[iii].dataset.seq = iii + 1
        }
        MikihouseCustomer.Register.addressRegister.childrenDelete()
        MikihouseCustomer.Register.addressRegister.childrenEdit()
        const field = document.querySelectorAll('.children-input-field')
        for (let i = 0; i < field.length; i++) {
          field[i].classList.add('hide')
        }
      },
      addKids: async () => {
        const kidsLastName = document.querySelector('#kid-lastname')
        const kidsFirstName = document.querySelector('#kid-firstname')
        const kidsLastNameKana = document.querySelector('#kid-lastnamekana')
        const kidsFirstNameKana = document.querySelector('#kid-firstnamekana')
        const kidsSex = document.querySelector('#kid-sex')
        const kidsRelation = document.querySelector('#kid-relation')
        const kidsBirthday = document.querySelector('#kid-birthday')
        const checkKidFirstName = await MIKIHOUSE.validation.validationName(kidsFirstName.value)
        const checkKidLastName = await MIKIHOUSE.validation.validationName(kidsLastName.value)
        const checkKidFirstNameKana = await MIKIHOUSE.validation.validationKanaName(kidsFirstNameKana.value)
        const checkKidLastNameKana = await MIKIHOUSE.validation.validationKanaName(kidsLastNameKana.value)
        const jsonContent = document.querySelector('#childrenListJson')
        MikihouseCustomer.Actions.errorTextReset()
        let json = JSON.parse(jsonContent.textContent)
        for (let i = 1; i < json.length; i++) {
          json[i].seq = i
        }
        if (json.length > 9) {
          alert(MIKIHOUSE['language'].customer[Shopify.locale].error47)
          return true
        }

        if (checkKidFirstName.error || checkKidLastName.error || checkKidFirstNameKana.error || checkKidLastNameKana.error) {
          MikihouseCustomer.Register.addressRegister.errorLogic(checkKidLastName, checkKidFirstName, checkKidLastNameKana, checkKidFirstNameKana)
          return true
        }
        const kids = {}
        const list = document.querySelector('#add-kids-list')
        kids['seq'] = json.length + 1
        kids['last_name'] = kidsLastName.value
        kids['first_name'] = kidsFirstName.value
        kids['last_name_kana'] = kidsLastNameKana.value
        kids['first_name_kana'] = kidsFirstNameKana.value
        kids['sex'] = kidsSex.value
        kids['born_flg'] = '1'
        kids['birthday'] = kidsBirthday.value
        kids['relationship'] = kidsRelation.value
        json.push(kids)
        for (let seq = 0; seq < json.length; seq++) {
          json[seq]['seq'] = seq + 1
        }
        jsonContent.textContent = JSON.stringify(json)
        const kidsHTML = MikihouseCustomer.Register.addressRegister.addChildrenList(kids, 'kids')

        list.innerHTML = list.innerHTML + kidsHTML
        const listItem = document.querySelectorAll('.kids-list')
        for (let iii = 0; iii < listItem.length; iii++) {
          listItem[iii].dataset.seq = iii + 1
        }
        MikihouseCustomer.Register.addressRegister.childrenDelete()
        MikihouseCustomer.Register.addressRegister.childrenEdit()
        const field = document.querySelectorAll('.children-input-field')
        for (let i = 0; i < field.length; i++) {
          field[i].classList.add('hide')
        }
      },
      addChildrenList: (children, section, editFlg = false) => {
        let kidsHTML = ''
        switch (children.sex) {
          case '1':
            sex_label = MIKIHOUSE['language'].customer[Shopify.locale].girl;
            break;
          case '9':
            sex_label = MIKIHOUSE['language'].customer[Shopify.locale].other;
            break;
          default:
            sex_label = MIKIHOUSE['language'].customer[Shopify.locale].boy;
        }
        if (editFlg == false) {
          kidsHTML = `
          <div class='kids-list' data-seq=${children.seq}>
            <div>
              <label class="${section == 'kids' ? 'hide' : ''}">${MIKIHOUSE['language'].customer[Shopify.locale].scheduled_date_of_birth}</label>
              <label class="${section == 'baby' ? 'hide' : ''}">${children.last_name} ${children.first_name}</label>
              <div>
                <div class="list-content">
                  <div class="${section == 'baby' ? 'hide' : ''}">
                    【${MIKIHOUSE['language'].customer[Shopify.locale].furigana}】: ${children.last_name_kana} ${children.first_name_kana}<br>
                    【${MIKIHOUSE['language'].customer[Shopify.locale].gender}】: ${sex_label}<br>
                    【${MIKIHOUSE['language'].customer[Shopify.locale].birthday}】: ${children.birthday}
                  </div>
                  <div class="${section == 'kids' ? 'hide' : ''}">
                    【${MIKIHOUSE['language'].customer[Shopify.locale].scheduled_date_of_birth}】${children.birthday}<br>
                    【${MIKIHOUSE['language'].customer[Shopify.locale].gender}】: ${sex_label}<br>
                  </div>
                </div>
                <div>
                  <a href='#kids-container' class='btn btn--secondary btn--small childrenEdit' data-target="${section == 'baby' ? 'baby-register-field' : 'children-register-field'}" data-seq=${children.seq}>${MIKIHOUSE['language'].customer[Shopify.locale].edit}</a>
                  <button type='button' class='btn btn--secondary btn--small childrenDelete' data-seq=${children.seq}>${MIKIHOUSE['language'].customer[Shopify.locale].delete}</button>
                </div>
              </div>
            </div>
          </div>`;
        } else {
          kidsHTML = `
          <div class="${section == 'baby' ? 'hide' : ''}">
            【${MIKIHOUSE['language'].customer[Shopify.locale].furigana}】: ${children.last_name_kana} ${children.first_name_kana}<br>
            【${MIKIHOUSE['language'].customer[Shopify.locale].gender}】: ${sex_label}<br>
            【${MIKIHOUSE['language'].customer[Shopify.locale].birthday}】: ${children.birthday}
          </div>
          <div class="${section == 'kids' ? 'hide' : ''}">
            【${MIKIHOUSE['language'].customer[Shopify.locale].scheduled_date_of_birth}】${children.birthday}<br>
            【${MIKIHOUSE['language'].customer[Shopify.locale].gender}】: ${sex_label}<br>
          </div>
          `
        }

        return kidsHTML
      },
      childrenDelete: () => {
        let result = []
        for (let i = 0; i < document.querySelectorAll('.childrenDelete').length; i++) {
          document.querySelectorAll('.childrenDelete')[i].addEventListener('click', (e) => {
            const jsonContent = document.querySelector('#childrenListJson')
            let json = JSON.parse(jsonContent.textContent)

            e.target.closest('.kids-list').remove()
            result = json.filter((item) => {
              return item.seq != Number(e.target.dataset.seq);
            });
            for (let ii = 0; ii < result.length; ii++) {
              result[ii].seq = ii + 1
            }

            jsonContent.textContent = JSON.stringify(result)
            const list = document.querySelectorAll('.kids-list')
            for (let iii = 0; iii < list.length; iii++) {

              list[iii].dataset.seq = iii + 1
            }
          })
        }
      },
      childrenEdit: () => {
        let result = []
        for (let i = 0; i < document.querySelectorAll('.childrenEdit').length; i++) {
          document.querySelectorAll('.childrenEdit')[i].addEventListener('click', (e) => {
            e.stopPropagation()
            const jsonContent = document.querySelector('#childrenListJson')
            const kidsLastName = document.querySelector('#kid-lastname')
            const kidsFirstName = document.querySelector('#kid-firstname')
            const kidsLastNameKana = document.querySelector('#kid-lastnamekana')
            const kidsFirstNameKana = document.querySelector('#kid-firstnamekana')
            const kidsRelation = document.querySelector('#kid-relation')
            const kidsSex = document.querySelector('#kid-sex')
            const kidsBirthday = document.querySelector('#kid-birthday')
            const babyBirthday = document.querySelector('#baby-birthday')
            const babyRelation = document.querySelector('#baby-relation')
            const babySex = document.querySelector('#baby-sex')
            const addBaby = document.querySelector('#add-baby-btn')
            const editBaby = document.querySelector('#edit-baby-btn')
            const addKids = document.querySelector('#add-kid-btn')
            const editKids = document.querySelector('#edit-kid-btn')
            let json = JSON.parse(jsonContent.textContent)
            const id = e.target.dataset.target
            const field = document.querySelectorAll('.children-input-field')
            for (let i = 0; i < field.length; i++) {
              field[i].classList.add('hide')
            }
            for (let ii = 0; ii < json.length; ii++) {
              if (json[ii].seq === Number(e.target.dataset.seq)) {
                result = json[ii]
              }
            }
            if (id.match(/baby/)) {
              babyBirthday.value = result.birthday
              babyRelation.value = result.relationship
              babySex.value = result.sex
              addBaby.style.display = 'none'
              editBaby.style.display = 'inline-block'
              editBaby.dataset.seq = e.target.dataset.seq
            } else {
              kidsLastName.value = result.last_name
              kidsFirstName.value = result.first_name
              kidsLastNameKana.value = result.last_name_kana
              kidsFirstNameKana.value = result.first_name_kana
              kidsRelation.value = result.relationship
              kidsSex.value = result.sex
              kidsBirthday.value = result.birthday
              addKids.style.display = 'none'
              editKids.style.display = 'inline-block'
              editKids.dataset.seq = e.target.dataset.seq
            }
            document.querySelector('#' + id).classList.remove('hide')


          })
        }
      },
      childrenEditer: async (evt, seq, step) => {
        evt.stopPropagation()
        const kidsLastName = document.querySelector('#kid-lastname')
        const kidsFirstName = document.querySelector('#kid-firstname')
        const kidsLastNameKana = document.querySelector('#kid-lastnamekana')
        const kidsFirstNameKana = document.querySelector('#kid-firstnamekana')
        const kidsRelation = document.querySelector('#kid-relation')
        const kidsSex = document.querySelector('#kid-sex')
        const kidsBirthday = document.querySelector('#kid-birthday')
        const babyBirthday = document.querySelector('#baby-birthday')
        const babyRelation = document.querySelector('#baby-relation')
        const babySex = document.querySelector('#baby-sex')
        const jsonContent = document.querySelector('#childrenListJson')
        const checkKidFirstName = await MIKIHOUSE.validation.validationName(kidsFirstName.value)
        const checkKidLastName = await MIKIHOUSE.validation.validationName(kidsLastName.value)
        const checkKidFirstNameKana = await MIKIHOUSE.validation.validationKanaName(kidsFirstNameKana.value)
        const checkKidLastNameKana = await MIKIHOUSE.validation.validationKanaName(kidsLastNameKana.value)
        const children = {}
        let childrenHTML;
        if (step == 'baby') {
          children['seq'] = Number(seq)
          children['last_name'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
          children['first_name'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
          children['last_name_kana'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
          children['first_name_kana'] = MIKIHOUSE['language'].customer[Shopify.locale].baby
          children['sex'] = babySex.value
          children['born_flg'] = '0'
          children['birthday'] = babyBirthday.value
          children['relationship'] = babyRelation.value
          childrenHTML = MikihouseCustomer.Register.addressRegister.addChildrenList(children, 'baby', true)
        } else {
          if (checkKidFirstName.error || checkKidLastName.error || checkKidFirstNameKana.error || checkKidLastNameKana.error) {
            MikihouseCustomer.Register.addressRegister.errorLogic(checkKidLastName, checkKidFirstName, checkKidLastNameKana, checkKidFirstNameKana)
            return true
          }
          children['seq'] = Number(seq)
          children['last_name'] = kidsLastName.value
          children['first_name'] = kidsFirstName.value
          children['last_name_kana'] = kidsLastNameKana.value
          children['first_name_kana'] = kidsFirstNameKana.value
          children['sex'] = kidsSex.value
          children['born_flg'] = '1'
          children['birthday'] = kidsBirthday.value
          children['relationship'] = kidsRelation.value
          childrenHTML = MikihouseCustomer.Register.addressRegister.addChildrenList(children, 'kids', true)
        }
        let json = JSON.parse(jsonContent.textContent)
        document.querySelector('.kids-list[data-seq="' + seq + '"] .list-content').innerHTML = childrenHTML
        for (let i = 0; i < json.length; i++) {
          if (json[i].seq === Number(seq)) {
            json[i] = children
          }
        }

        jsonContent.textContent = JSON.stringify(json)
        const field = document.querySelectorAll('.children-input-field')
        for (let i = 0; i < field.length; i++) {
          field[i].classList.add('hide')
        }
        // MikihouseCustomer.Register.addressRegister.childrenDelete()
        // MikihouseCustomer.Register.addressRegister.childrenEdit()
      },
      errorLogic: (checkKidLastName, checkKidFirstName, checkKidLastNameKana, checkKidFirstNameKana) => {
        if (checkKidFirstName.error) {
          document.querySelector('.errorKidFirstName').innerText = MIKIHOUSE['language'].customer[Shopify.locale].first_name + checkKidFirstName.error_message;
          document.querySelector('#kid-firstname').classList.add('error');
        }
        if (checkKidLastName.error) {
          document.querySelector('.errorKidLastName').innerText = MIKIHOUSE['language'].customer[Shopify.locale].last_name + checkKidLastName.error_message;
          document.querySelector('#kid-lastname').classList.add('error');
        }
        if (checkKidFirstNameKana.error) {
          document.querySelector('.errorKidFirstNameKana').innerText = MIKIHOUSE['language'].customer[Shopify.locale].first_name_kana + checkKidFirstNameKana.error_message;
          document.querySelector('#kid-firstnamekana').classList.add('error');
        }
        if (checkKidLastNameKana.error) {
          document.querySelector('.errorKidLastNameKana').innerText = MIKIHOUSE['language'].customer[Shopify.locale].last_name_kana + checkKidLastNameKana.error_message;
          document.querySelector('#kid-lastnamekana').classList.add('error');
        }
      },
      errorLogic2: (error, key) => {
        let prefix = ''
        if (key == 'last_name') {
          prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name
        } else if (key == 'first_name') {
          prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name
        } else if (key == 'last_name_kana') {
          prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name_kana
        } else if (key == 'first_name_kana') {
          prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name_kana
        }
        document.querySelector(`.errorMessage[data-target='${key}']`).innerText = prefix + error.error_message
        document.querySelector(`input[data-target='${key}']`).classList.add('error')
      }
    }
  },
  Login: {
    init: () => {
      const form = document.querySelector('#loginSubmit')
      const email = document.querySelector('#CustomerEmail')
      const password = document.querySelector('#CustomerPassword')
      if(navigator.userAgent.match(/Yappli|yappli/) && localStorage.getItem('loginMail') && localStorage.getItem('loginPassword')) {
        email.value = localStorage.getItem('loginMail')
        password.value = localStorage.getItem('loginPassword')
      }
      form.addEventListener('click', async (e) => {
        e.preventDefault()
        const cookie = MikihouseCustomer.Actions.getCustomerCookie()
        const loadingElement = document.querySelector('#loading')
        const email = document.querySelector('#CustomerEmail')
        const password = document.querySelector('#CustomerPassword')
        const checkCustomerMail = MIKIHOUSE.validation.validationEmail(email.value)
        const customerPasswdCheck = MIKIHOUSE.validation.validationPassword(password.value)
        const errorMail = document.querySelector('.errorMail')
        const errorPass = document.querySelector('.errorPass')
        loadingElement.classList.add('active')
        const errorReset = MikihouseCustomer.Actions.errorTextReset()
        let submitAction = false
        if (checkCustomerMail.error || customerPasswdCheck.error) {
          submitAction = false
        } else {
          submitAction = true
        }
        if (submitAction != true) {
          MikihouseCustomer.Login.errorLogic(checkCustomerMail, errorMail, email, customerPasswdCheck, errorPass, password)
          loadingElement.classList.remove('active');
          return false
        } else {
          if(cookie.referrerLocation) {
            if (
              cookie.referrerLocation.match(/pages\/account-register/) ||
              cookie.referrerLocation.match(/pages\/mail-authcode/) ||
              cookie.referrerLocation.match(/pages\/password-reset-authcode/) ||
              cookie.referrerLocation.match(/undefind/) ||
              cookie.referrerLocation.match(/account\//)
            ) {
              cookie.referrerLocation = location.origin + '/pages/onlineshop'
            }
          } else {
            cookie.referrerLocation = location.origin + '/pages/onlineshop'
          }
          
          const result = await MikihouseCustomer.Login.customerLogin(cookie, email.value, password.value)
          if (result.redirect_url) {
            // 機種変更や複数端末利用を想定し、ヤプリでのログイン時は毎回ヤプリSDKでの登録を行う
            if (MikihouseCustomer.YappliCaller.isYappliWebView() && result.member_no) {
              let result2 = await MikihouseCustomer.YappliCaller.registMemberNo(result.member_no);
              if (result2.status) {
                // ヤプリステータスが未連携の場合はヤプリステータスを更新する
                if (result.yappli_status !== '1') {
                  result2 = await MikihouseCustomer.YappliStatus.updateYappliStatus(result.crm_customer_id, result.access_token);
                  if (result2.status_code !== 1000) {
                    MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error48);
                    loadingElement.classList.remove('active');
                    return;
                  }
                }
              }
              else {
                MikihouseCustomer.Actions.errorContent('close', MIKIHOUSE['language'].customer[Shopify.locale].error49);
                loadingElement.classList.remove('active');
                return;
              }
            }
            await MikihouseCustomer.Actions.setCustomerCookie('access_token', result.access_token, '/')

            // /***20241108 kanehori ログインに関する書き換え***/
            // const newDomain = location.origin;
            // // ドメイン部分を置き換えたURLを作成
            // const rewrittenUrl = result.redirect_url.replace(/^https?:\/\/[^/]+/, newDomain);
            // location.href = rewrittenUrl
            // /***ログインに関する書き換え***/
            location.href = result.redirect_url;
          } else {
            MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/tokens')
            loadingElement.classList.remove('active');
          }
        }
      })
    },
    customerLogin: (cookie, email, password) => {
      if(navigator.userAgent.match(/Yappli|yappli/)) {
        localStorage.setItem('loginMail', email)
        localStorage.setItem('loginPassword', password)
      }
      const endpoint = 'tokens'
      const headers = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        'body': JSON.stringify({
          'mail': email,
          'callback_url': cookie.referrerLocation,
          'password': password
        })
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    },
    errorLogic: (checkCustomerMail, errorMail, customerMail, customerPasswdCheck, errorPass, customerPasswd) => {
      if (checkCustomerMail.error) {
        errorMail.innerText = checkCustomerMail.error_message;
        customerMail.classList.add('error');
      }
      if (customerPasswdCheck.error) {
        errorPass.innerText = customerPasswdCheck.error_message;
        customerPasswd.classList.add('error');
      }
    }
  },
  CustomerInfomation: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      const province = document.querySelector('#updateCustomerPrefecture')
      const submitBtn = document.querySelector('#updateActive')
      const form = document.forms['accountInfo']
      MikihouseCustomer.Actions.provinceNumberSet(province)
      form.addEventListener('submit', (e) => {
        MikihouseCustomer.CustomerInfomation.submitAction(e)
      })
    },
    submitAction: async (e) => {
      e.preventDefault()
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      const errorReset = MikihouseCustomer.Actions.errorTextReset()
      loadingElement.classList.add('active')
      const address = {}
      for (let i = 0; i < e.target.elements.length; i++) {
        const targetAddress = e.target.elements[i].dataset.address
        if (targetAddress && targetAddress != 'country') {
          address[targetAddress] = e.target.elements[i].value
        }
      }
      let errorFlg = false
      for (let key in address) {
        let error = false
        /**
         * 空白文字をreplace
         */


        /**
         * バリデーション
         */
        if (key == 'last_name' || key == 'first_name') {
          address[key] = address[key].trim()
          error = await MIKIHOUSE.validation.validationName(address[key])
        }
        if (key == 'last_name_kana' || key == 'first_name_kana') {
          address[key] = address[key].trim()
          error = await MIKIHOUSE.validation.validationKanaName(address[key])
        }
        if (key == 'zip') {
          error = await MIKIHOUSE.validation.validationZipcode(address[key])
        }
        if (key == 'city') {
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key], true, 24)
        }
        if (key == 'address1') {
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key], true)
        }
        if (key == 'address2') {
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key])
        }
        if (key == 'phone') {
          error = await MIKIHOUSE.validation.validationPhone(address[key])
        }
        if (error.error) {
          MikihouseCustomer.CustomerAddress.errorLogic(error, key)
          errorFlg = true
        }
      }

      if (errorFlg == true) {
        document.body.scrollIntoView();
        loadingElement.classList.remove('active')
      } else {
        console.log(address)
        const result = await MikihouseCustomer.CustomerInfomation.customerUpdate(cookie, address)
        if (result.status_code === 1000) {
          location.href = '?update=true'
        } else {
          MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/')
          loadingElement.classList.remove('active')
        }
      }
    },
    customerUpdate: (cookie, body) => {
      if (!cookie.customerId || cookie.customerId == 'false' || cookie.customerId == 'undefined') {
        cookie.customerId = localStorage.getItem('customerid')
      }
      const endpoint = cookie.customerId
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify(body)
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    },
    errorLogic: (error, key) => {
      let prefix = ''
      if (key == 'last_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name
      } else if (key == 'first_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name
      } else if (key == 'last_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name_kana
      } else if (key == 'first_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name_kana
      }

      document.querySelector('.errorMessage[data-target="' + key + '"]').innerText = prefix + error.error_message
      document.querySelector('input[data-address="' + key + '"]').classList.add('error');
    }
  },
  CustomerAddress: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      const newForm = document.querySelector('#address_form_new')
      const provinceList = document.querySelector('#AddressProvincesNew')
      const updateProvince = document.querySelectorAll('.updateProvince')
      const deleteBtn = document.querySelectorAll('.addressDelete')
      const editBtn = document.querySelectorAll('.updateForm')

      MikihouseCustomer.Actions.provinceNumberSet(provinceList)
      MikihouseCustomer.CustomerAddress.completeMessage()
      newForm.addEventListener('submit', (e) => MikihouseCustomer.CustomerAddress.addressUpdate(e))
      for (let i = 0; i < updateProvince.length; i++) {
        MikihouseCustomer.Actions.provinceNumberSet(updateProvince[i])
      }
      for (let i = 0; i < deleteBtn.length; i++) {
        deleteBtn[i].addEventListener('click', (e) => MikihouseCustomer.CustomerAddress.deleteAddress(e))
      }
      for (let i = 0; i < editBtn.length; i++) {
        editBtn[i].addEventListener('submit', (e) => MikihouseCustomer.CustomerAddress.editAddress(e))
      }
    },
    completeMessage: () => {
      if (location.search.match(/update=true/)) {
        const target = document.querySelector('#Complete')
        target.style.display = "block"
      }
    },
    addressUpdate: async (e) => {
      e.preventDefault()
      MikihouseCustomer.Actions.errorTextReset()
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      const address = {}
      for (let i = 0; i < e.target.elements.length; i++) {
        const targetAddress = e.target.elements[i].dataset.address
        if (targetAddress && targetAddress != 'country') {
          address[targetAddress] = e.target.elements[i].value
        }
      }
      MikihouseCustomer.CustomerAddress.submitEvt(address, e, loadingElement, cookie)
    },
    submitEvt: async (address, e, loadingElement, cookie, update = false) => {
      let errorFlg = false
      for (let key in address) {
        let error = false

        if (key == 'last_name' || key == 'first_name') {
          /**
           * 空白文字をreplace
           */
          address[key] = address[key].trim()
          error = await MIKIHOUSE.validation.validationName(address[key])
        }
        if (key == 'last_name_kana' || key == 'first_name_kana') {
          /**
           * 空白文字をreplace
           */
          address[key] = address[key].trim()
          error = await MIKIHOUSE.validation.validationKanaName(address[key])
        }
        if (key == 'zip') {
          error = await MIKIHOUSE.validation.validationZipcode(address[key])
        }
        if (key == 'city') {
          /**
           * 空白文字をreplace
           */
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key], true, 24)
        }
        if (key == 'address1') {
          /**
           * 空白文字をreplace
           */
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key], true)
        }
        if (key == 'address2') {
          /**
           * 空白文字をreplace
           */
          address[key] = address[key].replace(/\s/g, '')
          error = await MIKIHOUSE.validation.validationCity(address[key])
        }
        if (key == 'phone') {
          error = await MIKIHOUSE.validation.validationPhone(address[key])
        }


        if (error.error) {
          if (update == true) {
            MikihouseCustomer.CustomerAddress.errorLogic(error, key, true, address.seq)
          } else {
            MikihouseCustomer.CustomerAddress.errorLogic(error, key)
          }

          errorFlg = true
        }
      }
      const customerJsonContent = document.querySelector('#customerAddressList')
      let customerJson = JSON.parse(customerJsonContent.textContent)
      let list = customerJson.filter(e => e.seq != 0)
      let doubleCheck = customerJson.filter(e => e.last_name == address.last_name && e.first_name == address.first_name && e.last_name_kana == address.last_name_kana && e.phone == address.phone && e.zip == address.zip && e.city == address.city && e.address1 == address.address1 && e.address2 == address.address2)

      const updateCount = update == true ? 1 : 0
      if (doubleCheck.length > updateCount) {
        MikihouseCustomer.Actions.responseErrorModal(4003, '/')
        errorFlg = true
      }
      if (errorFlg == false) {
        if (update == true) {
          list = customerJson.filter(e => e.seq != 0 && e.seq != address.seq)
        } else {
          address['seq'] = Number(e.target.dataset.addressCounter)
        }
        list.push(address)
        const compareText = (a, b) => {
          if (a.seq > b.seq) return 1;
          if (a.seq < b.seq) return -1;
        }
        list.sort(compareText);
        const result = await MikihouseCustomer.CustomerAddress.submitAction(list, cookie)
        if (result.status_code === 1000) {
          location.href = '?update=true'
        } else {
          MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/delivery_addresses')
          loadingElement.classList.remove('active')
        }
      } else {
        loadingElement.classList.remove('active')
      }
    },
    editAddress: (e) => {
      e.preventDefault()
      const address = {}
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      const errorReset = MikihouseCustomer.Actions.errorTextReset()
      loadingElement.classList.add('active')
      for (let i = 0; i < e.target.elements.length; i++) {
        const targetAddress = e.target.elements[i].dataset.addressUpdate
        if (targetAddress && targetAddress != 'country') {
          address[targetAddress] = targetAddress == 'seq' ? Number(e.target.elements[i].value) : e.target.elements[i].value
        }
      }
      MikihouseCustomer.CustomerAddress.submitEvt(address, e, loadingElement, cookie, true)
    },
    submitAction: (body, cookie) => {
      const endpoint = cookie.customerId + '/delivery_addresses';
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify({
          addresses: body
        })
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    },
    deleteAddress: async (e) => {
      const customerJsonContent = document.querySelector('#customerAddressList')
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      let customerJson = JSON.parse(customerJsonContent.textContent)
      let list = customerJson.filter(elm => elm.seq != Number(e.target.dataset.addressId) && elm.seq !== 0)
      for (let i = 0; i < list.length; i++) {
        list[i].seq = i + 1
      }
      const result = await MikihouseCustomer.CustomerAddress.submitAction(list, cookie)
      if (result.status_code === 1000) {
        location.href = '?update=true'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/delivery_addresses')
        loadingElement.classList.remove('active')
      }
    },
    errorLogic: (error, key, updateFlg = false, seq = "") => {
      let prefix = ''
      let update = ''
      let updateWrap = ''
      if (key == 'last_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name
      } else if (key == 'first_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name
      } else if (key == 'last_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name_kana
      } else if (key == 'first_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name_kana
      }
      if (updateFlg) {
        update = '-update'
        updateWrap = '#EditAddress_' + seq + ' '
      }
      document.querySelector(`${updateWrap}.errorMessage[data-target${update}="${key}"]`).innerText = prefix + error.error_message
      document.querySelector(`${updateWrap}input[data-address${update}="${key}"]`).classList.add('error');
    }
  },
  ChildrenInfomation: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      const modalToggleBtn = document.querySelectorAll('.children-new-toggle')
      const modalClose = document.querySelectorAll('.wl-modal-bg')
      const modalCloseBtn = document.querySelectorAll('.closeBtn')
      const childrenEditBtn = document.querySelectorAll('.children-edit-toggle')
      const childrenDeleteBtn = document.querySelectorAll('.childrenDelete')
      const babyAddForm = document.forms['babyAddForm']
      const childrenAddForm = document.forms['childrenAddForm']
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      MikihouseCustomer.ChildrenInfomation.modalOpenEvt(modalToggleBtn)
      MikihouseCustomer.ChildrenInfomation.modalOpenEvt(modalClose)
      MikihouseCustomer.ChildrenInfomation.modalOpenEvt(modalCloseBtn)
      MikihouseCustomer.ChildrenInfomation.completeMessage()
      childrenAddForm.addEventListener('submit', (e) => MikihouseCustomer.ChildrenInfomation.submitAction(e))
      babyAddForm.addEventListener('submit', (e) => MikihouseCustomer.ChildrenInfomation.submitAction(e))
      for (let i = 0; i < childrenEditBtn.length; i++) {
        childrenEditBtn[i].addEventListener('click', e => MikihouseCustomer.ChildrenInfomation.editChildren(e))
      }
      for (let i = 0; i < childrenDeleteBtn.length; i++) {
        childrenDeleteBtn[i].addEventListener('click', e => MikihouseCustomer.ChildrenInfomation.deleteChildren(e))
      }
    },
    completeMessage: () => {
      if (location.search.match(/update=true/)) {
        const target = document.querySelector('#Complete')
        target.style.display = "block";
        target.innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].error50;
      }
    },
    modalOpenEvt: (elm) => {
      const jsonContent = document.querySelector('#childrenList')
      const json = JSON.parse(jsonContent.textContent)
      const seqElement = document.querySelectorAll('input[data-target="seq"]')
      const babyAddForm = document.forms['babyAddForm']
      const childrenAddForm = document.forms['childrenAddForm']
      const bornFlgUpdate = document.querySelector('#bornFlgUpdate')

      for (let i = 0; i < elm.length; i++) {
        elm[i].addEventListener('click', e => {
          if (e.target.dataset.target == 'babyNewForm') {
            bornFlgUpdate.checked = false
            document.querySelector('label[for="babyBirthday"]').innerHTML = '出産予定日'
            for (let i = 0; i < babyAddForm.elements.length; i++) {
              let target1 = babyAddForm.elements[i].dataset.target
              if (target1 == 'last_name' || target1 == 'first_name' || target1 == 'last_name_kana' || target1 == 'first_name_kana') {
                babyAddForm.elements[i].setAttribute('type', 'hidden')
                babyAddForm.elements[i].value = MIKIHOUSE['language'].customer[Shopify.locale].baby
                document.querySelector(`label[for=${babyAddForm.elements[i].getAttribute('id')}]`).classList.add('hide')
              }
              if (target1 == 'sex' || target1 == 'relationship') {
                babyAddForm.elements[i].options[0].selected = true
              }
              if (target1 == 'birthday') {
                babyAddForm.elements[i].value = dayjs().format('YYYY-MM-DD')
              }
            }
            babyAddForm.dataset.editFlg = true
            bornFlgUpdate.closest('div').classList.remove('hide')
          } else {
            bornFlgUpdate.checked = false
            for (let i = 0; i < childrenAddForm.elements.length; i++) {
              let target1 = childrenAddForm.elements[i].dataset.target
              if (target1 == 'last_name' || target1 == 'first_name' || target1 == 'last_name_kana' || target1 == 'first_name_kana') {
                childrenAddForm.elements[i].value = ''
              }
              if (target1 == 'sex' || target1 == 'relationship') {
                childrenAddForm.elements[i].options[0].selected = true
              }
              if (target1 == 'birthday') {
                childrenAddForm.elements[i].value = dayjs().format('YYYY-MM-DD')
              }
            }
          }
          bornFlgUpdate.closest('div').classList.add('hide')
          document.querySelector('#' + e.target.dataset.target).classList.toggle('hide')
          babyAddForm.dataset.editFlg = false
          childrenAddForm.dataset.editFlg = false
          for (let ii = 0; ii < seqElement.length; ii++) {
            seqElement[ii].value = json.length
          }
        })
      }

    },
    editChildren: (e) => {
      const jsonContent = document.querySelector('#childrenList')
      const bornFlgUpdate = document.querySelector('#bornFlgUpdate')
      const json = JSON.parse(jsonContent.textContent)
      const babyAddForm = document.forms['babyAddForm']
      const childrenAddForm = document.forms['childrenAddForm']
      const target = json.filter(elm => elm.seq == e.target.dataset.target)

      if (target[0].born_flg == '0') {
        bornFlgUpdate.checked = false
        for (let i = 0; i < babyAddForm.elements.length; i++) {
          let target1 = babyAddForm.elements[i].dataset.target
          if (target1 == 'last_name' || target1 == 'first_name' || target1 == 'last_name_kana' || target1 == 'first_name_kana') {
            babyAddForm.elements[i].setAttribute('type', 'hidden')
            document.querySelector(`label[for=${babyAddForm.elements[i].getAttribute('id')}]`).classList.add('hide')
          }
        }
        babyAddForm.dataset.editFlg = true
        bornFlgUpdate.closest('div').classList.remove('hide')
        bornFlgUpdate.addEventListener('change', (e) => {
          if (e.target.checked) {
            document.querySelector('label[for="babyBirthday"]').innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].birthday
          } else {
            document.querySelector('label[for="babyBirthday"]').innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].scheduled_date_of_birth
          }
          const ViewList = ['last_name', 'first_name', 'last_name_kana', 'first_name_kana']
          for (let i = 0; i < babyAddForm.elements.length; i++) {
            let target = babyAddForm.elements[i].dataset.target
            if (target == 'last_name' || target == 'first_name' || target == 'last_name_kana' || target == 'first_name_kana') {
              babyAddForm.elements[i].value = ""
              if (e.target.checked == true) {
                babyAddForm.elements[i].setAttribute('type', 'text')
                document.querySelector(`label[for=${babyAddForm.elements[i].getAttribute('id')}]`).classList.remove('hide')
              } else {
                babyAddForm.elements[i].setAttribute('type', 'hidden')
                document.querySelector(`label[for=${babyAddForm.elements[i].getAttribute('id')}]`).classList.add('hide')
              }
            }
            if (target == 'born_flg') {
              if (e.target.checked == true) {
                babyAddForm.elements[i].value = '1'
              } else {
                babyAddForm.elements[i].value = '0'
              }
            }
          }
        })
        MikihouseCustomer.ChildrenInfomation.setUpdateChildren(babyAddForm, target)
      } else {
        childrenAddForm.dataset.editFlg = true
        MikihouseCustomer.ChildrenInfomation.setUpdateChildren(childrenAddForm, target)
      }
    },
    deleteChildren: async (e) => {
      const jsonContent = document.querySelector('#childrenList')
      const json = JSON.parse(jsonContent.textContent)
      const target = json.filter(elm => elm.seq != e.target.dataset.target)
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      for (let i = 0; i < target.length; i++) {
        target[i].seq = i + 1
        target[i].birthday = dayjs(target[i].birthday).format('YYYY-MM-DD')
      }
      const result = await MikihouseCustomer.ChildrenInfomation.submitActions(target, cookie)
      if (result.status_code == 1000) {
        location.href = '?update=true'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/children')
        loadingElement.classList.remove('active')
      }
    },
    setUpdateChildren: (targetElement, target) => {
      targetElement.closest('.wl-modal').classList.toggle('hide')
      for (let i = 0; i < targetElement.elements.length; i++) {
        const key = targetElement.elements[i].dataset.target
        for (let k in target[0]) {
          if (key == k) {
            if (k == 'relationship' || k == 'sex') {
              for (let ii = 0; ii < targetElement.elements[i].options.length; ii++) {
                if (targetElement.elements[i].options[ii].value == target[0][k]) {
                  targetElement.elements[i].options[ii].selected = true
                }
              }
            } else {
              targetElement.elements[i].value = k == 'birthday' ? dayjs(target[0][k]).format('YYYY-MM-DD') : target[0][k]
            }
          }
        }
      }
    },
    submitAction: async (e) => {
      e.preventDefault()
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      const jsonContent = document.querySelector('#childrenList')
      const errorReset = MikihouseCustomer.Actions.errorTextReset()
      let json = JSON.parse(jsonContent.textContent)
      const children = {}
      for (let i = 0; i < e.target.elements.length; i++) {
        const key = e.target.elements[i].dataset.target
        if (key) {
          children[key] = key == 'seq' ? Number(e.target.elements[i].value) + 1 : e.target.elements[i].value
        }
      }
      for (let i = 0; i < json.length; i++) {
        json[i].birthday = dayjs(json[i].birthday).format('YYYY-MM-DD')
      }
      if (e.target.dataset.editFlg == true || e.target.dataset.editFlg == 'true') {
        children.seq = children.seq - 1
        json = json.filter(elm => elm.seq !== children.seq)
      }
      const compareText = (a, b) => {
        if (a.seq > b.seq) return 1;
        if (a.seq < b.seq) return -1;
      }
      let errorFlg = false
      for (let key in children) {
        let error = false
        if (key == 'last_name' || key == 'first_name') {
          children[key] = children[key].trim()
          error = await MIKIHOUSE.validation.validationName(children[key])
        }
        if (key == 'last_name_kana' || key == 'first_name_kana') {
          children[key] = children[key].trim()
          error = await MIKIHOUSE.validation.validationKanaName(children[key])
        }
        if (error.error) {
          MikihouseCustomer.ChildrenInfomation.errorLogic(error, key)
          errorFlg = true
        }
      }
      if (errorFlg == true) {
        loadingElement.classList.remove('active')
        return false
      }
      json.push(children)
      json.sort(compareText);
      const result = await MikihouseCustomer.ChildrenInfomation.submitActions(json, cookie)
      if (result.status_code == 1000) {
        location.href = '?update=true'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/children')
        loadingElement.classList.remove('active')
      }
    },
    submitActions: (body, cookie) => {
      const endpoint = cookie.customerId + '/children';
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify({
          children: body
        })
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    },
    errorLogic: (error, key) => {
      let prefix = ''
      if (key == 'last_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name
      } else if (key == 'first_name') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name
      } else if (key == 'last_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].last_name_kana
      } else if (key == 'first_name_kana') {
        prefix = MIKIHOUSE['language'].customer[Shopify.locale].first_name_kana
      }
      document.querySelector('.errorMessage[data-target="' + key + '"]').innerText = prefix + error.error_message
      document.querySelector('input[data-target="' + key + '"]').classList.add('error');
    }

  },
  MailUpdate: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      const form = document.forms['mailUpdate']
      MikihouseCustomer.MailUpdate.completeMessage()
      form.addEventListener('submit', (e) => MikihouseCustomer.MailUpdate.submitAction(e))
    },
    completeMessage: () => {
      if (location.search.match(/update=true/)) {
        const target = document.querySelector('#Complete')
        target.style.display = "block";
        target.innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].error51;
      }
    },
    submitAction: async (e) => {
      e.preventDefault()
      const array = {}
      let errorFlg = false
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      const errorReset = MikihouseCustomer.Actions.errorTextReset()
      loadingElement.classList.add('active')
      for (let i = 0; i < e.target.elements.length; i++) {
        const target = e.target.elements[i]
        if (target.dataset.target) {
          array[target.dataset.target] = e.target.elements[i].value
        }
      }
      if (array.old_confirmation != array.old_mail) {
        document.querySelector('.errorupdateOldMail').innerText = MIKIHOUSE['language'].customer[Shopify.locale].error52
        document.querySelector('input[data-target="old_mail"]').classList.add('error')
        errorFlg = true
      }
      const newMailValidation = await MIKIHOUSE.validation.validationEmail(array.new_mail)
      if (newMailValidation.error) {
        document.querySelector('.errorupdateNewMail').innerText = newMailValidation.error_message
        document.querySelector('input[data-target="new_mail"]').classList.add('error')
        errorFlg = true
      }
      if (array.new_mail != array.confirmation) {
        document.querySelector('.errorupdateNewMailCheck').innerText = MIKIHOUSE['language'].customer[Shopify.locale].error53
        document.querySelector('input[data-target="new_mail"]').classList.add('error')
        document.querySelector('input[data-target="confirmation"]').classList.add('error')
        errorFlg = true
      }
      const body = {
        'new_mail': array.new_mail,
        'old_mail': array.old_mail,
      }

      if (errorFlg != true) {
        const result = await MikihouseCustomer.MailUpdate.submitEvt(body, cookie)
        if (result.status_code == 1000) {
          localStorage.setItem('upemail', updateNewMail.value);
          location.href = '/pages/mail-authcode';
        } else {
          MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/children')
          loadingElement.classList.remove('active')
        }
      } else {
        loadingElement.classList.remove('active')
      }
    },
    submitEvt: (body, cookie) => {
      const endpoint = cookie.customerId + '/mail';
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify(body)
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  PasswordUpdate: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      MikihouseCustomer.PasswordUpdate.completeMessage()
      const form = document.forms['passwordUpdate']
      form.addEventListener('submit', (e) => MikihouseCustomer.PasswordUpdate.submitAction(e))
    },
    completeMessage: () => {
      if (location.search.match(/update=true/)) {
        const target = document.querySelector('#Complete')
        target.style.display = "block";
        target.innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].error54
      }
    },
    submitAction: async (e) => {
      e.preventDefault()
      const array = {}
      let errorFlg = false
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      const errorReset = MikihouseCustomer.Actions.errorTextReset()
      loadingElement.classList.add('active')
      for (let i = 0; i < e.target.elements.length; i++) {
        const target = e.target.elements[i]
        if (target.dataset.target) {
          array[target.dataset.target] = e.target.elements[i].value
        }
      }

      const newPasswordValidation = await MIKIHOUSE.validation.validationPassword(array.new_password)
      if (newPasswordValidation.error) {
        document.querySelector('.errorupdateNewPassword').innerText = newPasswordValidation.error_message
        document.querySelector('input[data-target="new_password"]').classList.add('error')
        errorFlg = true
      }
      if (array.new_password != array.confirmation) {
        document.querySelector('.errorupdateNewPasswordCheck').innerText = MIKIHOUSE['language'].customer[Shopify.locale].error55
        document.querySelector('input[data-target="new_password"]').classList.add('error')
        document.querySelector('input[data-target="confirmation"]').classList.add('error')
        errorFlg = true
      }
      const body = {
        'new_password': array.new_password,
        'old_password': array.old_password,
      }

      if (errorFlg != true) {
        const result = await MikihouseCustomer.PasswordUpdate.submitEvt(body, cookie)
        if (result.status_code == 1000) {
          location.href = '?update=true';
        } else {
          MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/children')
          loadingElement.classList.remove('active')
        }
      } else {
        loadingElement.classList.remove('active')
      }
    },
    submitEvt: (body, cookie) => {
      const endpoint = cookie.customerId + '/password';
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify(body)
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  MailMagaginUpdate: {
    init: () => {
      MikihouseCustomer.Actions.coercionLogout()
      MikihouseCustomer.MailMagaginUpdate.completeMessage()
      const mailMarketingFlg = document.querySelector('input[name="address[accepts_marketing_flg]"]')
      mailMarketingFlg.addEventListener('change', (e) => MikihouseCustomer.MailMagaginUpdate.changeAction(e))
    },
    completeMessage: () => {
      if (location.search.match(/update=true/)) {
        const target = document.querySelector('#Complete')
        target.style.display = "block";
        target.innerHTML = MIKIHOUSE['language'].customer[Shopify.locale].error56
      }
    },
    changeAction: async (e) => {
      const checked = e.target.checked
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      const jsonContent = document.querySelector('#address')
      const json = JSON.parse(jsonContent.textContent)
      loadingElement.classList.add('active')
      let result = json.filter(e => e.seq == 0 && e.home_flg == true)
      delete result[0]['seq']
      delete result[0]['home_flg']
      if (checked) {
        result[0]['mail_magazine_flg'] = '0'
      } else {
        result[0]['mail_magazine_flg'] = '1'
      }
      result = await MikihouseCustomer.MailMagaginUpdate.submitActions(result[0], cookie)
      if (result.status_code == 1000) {
        location.href = '?update=true'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/')
      }
    },
    submitActions: (body, cookie) => {
      const endpoint = cookie.customerId
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        },
        'body': JSON.stringify(body)
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  Logout: {
    init: () => {
      const btn = document.querySelectorAll('.logoutBtn')
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      for (let i = 0; i < btn.length; i++) {
        btn[i].addEventListener('click', async (e) => {
          loadingElement.classList.add('active')
          const result = await MikihouseCustomer.Logout.submitAction(e, cookie)

          if (result.callback_url) {
            fetch('/account/logout').then(() => {
              location.href = "/pages/onlineshop";
            }).catch(() => { 
              MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/tokens')
              loadingElement.classList.remove('active')
            });
          } else {
            MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/tokens')
            loadingElement.classList.remove('active')
          }
        })
      }
    },
    submitAction: (e, cookie) => {
      // const endpoint =  'tokens/' + cookie.customerId + '?callback_url=https://official-mikihouse.myshopify.com/account/logout'
      const endpoint = `tokens/${cookie.customerId}?callback_url=https://${MIKIHOUSE.SHOP_DOMAIN + Shopify.routes.root}account/logout`;
      const headers = {
        'method': 'DELETE',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        }
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  Withdrawal: {
    init: async () => {
      MikihouseCustomer.Actions.coercionLogout()
      const accountWithdrawalBtn = document.querySelector('#accountWithdrawal')
      const accountWithdrawalSubmitBtn = document.querySelector('#accountWithdrawalSubmitBtn')
      const cookie = MikihouseCustomer.Actions.getCustomerCookie()
      const loadingElement = document.querySelector('#loading')
      accountWithdrawalBtn.addEventListener('click', async (e) => {
        loadingElement.classList.add('active')
        var WithdrawalCheck = confirm(MIKIHOUSE['language'].customer[Shopify.locale].error57)
        if (WithdrawalCheck) {
          const result = await MikihouseCustomer.Withdrawal.submitActions(cookie);
          if (result) {
            await MikihouseCustomer.Logout.submitAction(e, cookie)
            accountWithdrawalSubmitBtn.click();
          }
        } else {
          loadingElement.classList.remove('active')
        }
      });
    },
    submitActions: (cookie) => {
      const endpoint = cookie.customerId
      const headers = {
        'method': 'DELETE',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': cookie.accessToken
        }
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  passwordRecovoery: {
    init: () => {
      const form = document.forms['recoverPassword']
      form.addEventListener('submit', (e) => MikihouseCustomer.passwordRecovoery.submitAction(e))
    },
    submitAction: async (e) => {
      e.preventDefault()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      const array = {}
      for (let i = 0; i < e.target.elements.length; i++) {
        let key = e.target.elements[i].dataset.target
        if (key) {
          array[key] = e.target.elements[i].value
        }
      }
      const result = await MikihouseCustomer.passwordRecovoery.submitEvt(array)
      if (result.status_code === 1000) {
        localStorage.setItem('resetPassMail', array.mail)
        localStorage.setItem('security_cd', result.security_cd)
        localStorage.setItem('system_datetime', result.system_datetime)
        location.href = '/pages/password-reset-authcode'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/tokens', true)
        loadingElement.classList.remove('active')
      }
    },
    submitEvt: (body) => {
      const endpoint = 'password_reset'
      const headers = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        'body': JSON.stringify(body)
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  passwordAuthenticate: {
    init: () => {
      const form = document.forms['ResetPassword']
      form.addEventListener('submit', (e) => MikihouseCustomer.passwordAuthenticate.submitAction(e))
    },
    submitAction: (e) => {
      e.preventDefault()
      const loadingElement = document.querySelector('#loading')
      loadingElement.classList.add('active')
      const array = {}
      for (let i = 0; i < e.target.elements.length; i++) {
        let key = e.target.elements[i].dataset.target
        if (key) {
          array[key] = e.target.elements[i].value
        }
      }
      let errorFlg = false
      for (let key in array) {
        let error = false
        if (key == 'confirmation_code') {
          error = MIKIHOUSE.validation.validationAuthcode(array[key])
        }
        if (key == 'new_password') {
          error = MIKIHOUSE.validation.validationPassword(array[key])
        }
        if (error.error) {
          errorFlg = true
          MikihouseCustomer.passwordAuthenticate.errorLogic(error, key)
        }
      }
      if (array['new_password'] !== array['new_password_confirmation']) {
        errorFlg = true
        document.querySelector('.errorMessage[data-target="new_password_confirmation"]').innerText = MIKIHOUSE['language'].customer[Shopify.locale].error59
        document.querySelector('input[data-target="new_password_confirmation"]').classList.add('error');
      }

      if (errorFlg == false) {
        const result = MikihouseCustomer.passwordAuthenticate.submitActionEvt(array, loadingElement)

      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/password_authenticate')
        loadingElement.classList.remove('active')
      }
    },
    submitActionEvt: async (body, loadingElement) => {
      const endpoint = 'password_authenticate'
      if (localStorage.getItem('system_datetime')) {
        body['security_cd'] = localStorage.getItem('security_cd')
        body['system_datetime'] = localStorage.getItem('system_datetime')
        body['mail'] = localStorage.getItem('resetPassMail')
      }

      const headers = {
        'method': 'POST',
        'headers': {
          'Content-Type': 'application/json'
        },
        'body': JSON.stringify(body)
      }
      const result = await MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      if (result.status_code == 1000) {
        location.href = '/account/login?password_reset=true'
      } else {
        MikihouseCustomer.Actions.responseErrorModal(result.status_code, '/password_authenticate')
        loadingElement.classList.remove('active')
      }
      return result
    },
    errorLogic: (error, key) => {
      document.querySelector('.errorMessage[data-target="' + key + '"]').innerText = error.error_message
      document.querySelector('input[data-target="' + key + '"]').classList.add('error');
    }
  },
  YappliStatus: {
    init: () => {
      // NOP
    },
    updateYappliStatus: (customer_id, access_token) => {
      const endpoint = customer_id + '/yappli_status';
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': access_token
        },
        'body': JSON.stringify({
          'yappli_status': '1',
        })
      }
      const result = MikihouseCustomer.Actions.fetchCustomer(endpoint, headers)
      return result
    }
  },
  YappliCaller: {
    init: () => {
      // NOP
    },
    isYappliWebView: () => {
      return Boolean(navigator.userAgent.match(/ ?yappli ?/i));
    },
    _registMemberNoInner: (member_no) => {
      return new Promise((resolve, reject) => {
        const registered_id = JSON.stringify({ 'registered_id': member_no });
        Yappli.sendRegisteredId(registered_id, (result, error_message) => {
          if (result) {
            resolve({
              'status': result,
              'error_message': null,
            })
          }
          else {
            reject({
              'status': result,
              'error_message': error_message
            })
          }
        });
      }).catch((reason) => {
        console.log(reason);
        if (reason.status === false && reason.error_message) {
          return reason;
        }
        else {
          return {
            'status': false,
            'error_message': MIKIHOUSE['language'].customer[Shopify.locale].error58,
          }
        }
      })
    },
    registMemberNo: async (member_no) => {
      let retry_count = 5;
      let result = {
        'status': true,
        'error_message': null,
      }
      // 本番環境以外では成功扱いとする
      if (MIKIHOUSE.SHOP_DOMAIN !== 'official-mikihouse.myshopify.com') {
        return result;
      }
      for (let index = 0; index < retry_count; index++) {
        result = await MikihouseCustomer.YappliCaller._registMemberNoInner(member_no);
        if (result.status) {
          break;
        }
        else {
          // 100ms待つ
          await MIKIHOUSE.sleep(100);
        }
      }
      return result;
    }
  },
  Shop: {
    init: () => {
      MikihouseCustomer.Shop.shops = [];
    },
    getList: async (customer_id, access_token) => {
      const headers = {
        'method': 'GET',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': access_token
        },
      }
      const result = await new Promise((resolve, reject) => {
        const url = `${MIKIHOUSE.BASE_CUSTOMER_API_URL}/api/v1/frontend/shop/list?id=${customer_id}`;
        fetch(url, headers)
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(error => reject(error))
      });
      if (result.status_code === 1000) {
        MikihouseCustomer.Shop.shops = result.records
      }
      return result;
    },
    filterByPrefecture: (prefecture) => {
      const shops = MikihouseCustomer.Shop.shops;
      if (!prefecture || prefecture.length <= 0) {
        return shops;
      }
      const filteredShops = shops.filter(shop => shop.pref === prefecture);
      filteredShops.unshift(shops.filter(shop => shop.shop_id === 0)[0]);//オフィシャルECサイトも出す
      return filteredShops;
    },
    filterByGeoLocation: (lat, lng, distance) => {
      const shops = MikihouseCustomer.Shop.shops;
      const filteredShops = [];
      for (const shop of shops) {
          // 距離が3000km以内の店舗のみに絞り込み
          let calculatedDistance = MikihouseCustomer.Shop.calcDistance(lat, lng, shop.lat, shop.lng);
          if (calculatedDistance <= distance) {
            shop.distance = calculatedDistance;
          filteredShops.push(shop);
        }
      }
      filteredShops.sort((a,b) => a.distance - b.distance);
      filteredShops.unshift(shops.filter(shop => shop.shop_id === 0)[0]);//オフィシャルECサイトも出す
      console.log('近い店舗',filteredShops);
      return filteredShops;
    },
    filterByGeoLocationWithGetCurrentPosition: async () => {
      return new Promise((resolve, reject) => {
        console.time('promise');
        if (!navigator.geolocation || !navigator.geolocation.getCurrentPosition) {
          reject('位置情報を取得できませんでした。設定をご確認ください。');
        }
        // 現在位置の取得
        MIKIHOUSE.Loading.show();
        navigator.geolocation.getCurrentPosition(function(position) {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
           // 半径3000km圏内の店舗を返す
          const filteredShops = MikihouseCustomer.Shop.filterByGeoLocation(lat, lng, 3000);
          resolve(filteredShops);
          MIKIHOUSE.Loading.hide();
        }, function(error) {
          reject('位置情報を取得できませんでした。設定をご確認ください。');
          MIKIHOUSE.Loading.hide();
        }, {
          timeout: 10000, // 10秒
        });
      }).catch((reason) => {
        reject('位置情報を取得できませんでした。設定をご確認ください。');
        MIKIHOUSE.Loading.hide();
        console.timeEnd('promise');
      });
    },
    calcDistance: (lat1, lng1, lat2, lng2) => {
      const R = Math.PI / 180;
      lat1 *= R;
      lng1 *= R;
      lat2 *= R;
      lng2 *= R;
      return 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
    },
    getShopConsiderLocale: (shop) => {
      const locale = Shopify.locale.toLowerCase();
      let result = {
        shop_id: shop.shop_id,
        shop_no: shop.shop_no,
        pref: shop.pref,
        lng: shop.lng,
        lat: shop.lat,
      };
  
      // 日本語
      if (locale === 'ja') {
        result.name = shop.name;
        result.address1 = shop.address1;
        result.address2 = shop.address2;
        result.tel_no = shop.tel_no;
      }
      // 中国語（簡体字）
      else if (locale === 'zh-cn') {
        result.name = shop.name_sc;
        result.address1 = shop.address1_sc;
        result.address2 = shop.address2_sc;
        result.tel_no = shop.tel_no_sc;
      }
      // 中国語（繁体字）
      else if (locale === 'zh-tw') {
        result.name = shop.name_tc;
        result.address1 = shop.address1_tc;
        result.address2 = shop.address2_tc;
        result.tel_no = shop.tel_no_tc;
      }
      // 英語と言語対応されていないロケール（韓国語）は英語で表示）
      else {
        result.name = shop.name_en;
        result.address1 = shop.address1_en;
        result.address2 = shop.address2_en;
        result.tel_no = shop.tel_no_en;
      }
  
      return result;
    },
  },
  MyShop: {
    get: async (customerId, accessToken) => {
      const headers = {
        'method': 'GET',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': accessToken,
        },
      };
      const result = await new Promise((resolve, reject) => {
        const url = `${MIKIHOUSE.BASE_CUSTOMER_API_URL}/api/v1/frontend/customers/${customerId}/myshop`;
        fetch(url, headers)
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(error => reject(error))
      });
      return result;
    },
    update: async (customerId, accessToken, myshops) => {
      const headers = {
        'method': 'PUT',
        'headers': {
          'Content-Type': 'application/json',
          'X-Mikihouse-Crm-Access-Token': accessToken,
        },
        'body': JSON.stringify({
          'myshop': myshops,
        }),
      };
      const result = await new Promise((resolve, reject) => {
        const url = `${MIKIHOUSE.BASE_CUSTOMER_API_URL}/api/v1/frontend/customers/${customerId}/myshop`;
        fetch(url, headers)
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(error => reject(error))
      });
      if (result.status_code === 1000) {
        return true;
      }
      else {
        return false;
      }
    },
  },
}